(function () {
  const roots = document.querySelectorAll("[data-toda-reference]");
  if (!roots.length) return;

  const cartUrlRoot = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || "/";

  roots.forEach(function (root) {
    const toast = root.querySelector(".toast");
    const countEl = root.querySelector("[data-toda-cart-count]");
    let toastTimer;

    function notify(message) {
      if (!toast) return;
      toast.textContent = message;
      toast.classList.add("show");
      window.clearTimeout(toastTimer);
      toastTimer = window.setTimeout(function () {
        toast.classList.remove("show");
      }, 1300);
    }

    function setCount(count) {
      if (!countEl || typeof count !== "number") return;
      countEl.textContent = String(count);
    }

    root.querySelectorAll("[data-toda-wish]").forEach(function (button) {
      button.addEventListener("click", function (event) {
        event.preventDefault();
        event.stopPropagation();
        button.classList.toggle("is-active");
      });
    });

    function setFramePlaying(video, isPlaying) {
      const frame = video && video.closest("[data-toda-video-toggle]");
      if (!frame) return;
      frame.classList.toggle("is-playing", Boolean(isPlaying));
    }

    function playVideo(video) {
      if (!video) return;
      const clickOnly = video.hasAttribute("data-toda-click-video") || video.closest("[data-toda-click-video]");
      root.querySelectorAll("video").forEach(function (otherVideo) {
        if (otherVideo !== video) {
          otherVideo.pause();
          setFramePlaying(otherVideo, false);
        }
      });
      video.muted = !clickOnly;
      if (clickOnly) {
        video.removeAttribute("muted");
      } else {
        video.setAttribute("muted", "");
      }
      const playRequest = video.play();
      if (playRequest && typeof playRequest.catch === "function") {
        playRequest
          .then(function () {
            setFramePlaying(video, true);
          })
          .catch(function () {});
      } else {
        setFramePlaying(video, true);
      }
    }

    root.querySelectorAll("[data-toda-video-toggle]").forEach(function (frame) {
      const video = frame.querySelector("video[data-toda-video], video");
      if (!video) return;
      const clickOnly = frame.hasAttribute("data-toda-click-video") || video.hasAttribute("data-toda-click-video");
      frame.setAttribute("role", "button");
      frame.setAttribute("tabindex", "0");
      video.addEventListener("play", function () {
        setFramePlaying(video, true);
      });
      video.addEventListener("pause", function () {
        setFramePlaying(video, false);
      });
      video.addEventListener("ended", function () {
        setFramePlaying(video, false);
      });
      frame.addEventListener("click", function () {
        if (clickOnly && !video.paused && !video.ended) {
          video.pause();
          return;
        }
        playVideo(video);
      });
      frame.addEventListener("keydown", function (event) {
        if (event.key !== "Enter" && event.key !== " ") return;
        event.preventDefault();
        if (clickOnly && !video.paused && !video.ended) {
          video.pause();
          return;
        }
        playVideo(video);
      });
    });

    if ("IntersectionObserver" in window) {
      const observer = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            const video = entry.target;
            if (entry.isIntersecting) {
              video.muted = true;
              const playRequest = video.play();
              if (playRequest && typeof playRequest.catch === "function") {
                playRequest.catch(function () {});
              }
            } else {
              video.pause();
            }
          });
        },
        { threshold: 0.45 }
      );

      root.querySelectorAll("video[data-toda-video]").forEach(function (video) {
        if (video.hasAttribute("data-toda-click-video") || video.closest("[data-toda-click-video]")) return;
        observer.observe(video);
      });
    }

    root.querySelectorAll("[data-toda-product-form]").forEach(function (form) {
      form.addEventListener("submit", function (event) {
        event.preventDefault();

        const button = form.querySelector(".add-button");
        if (button && button.disabled) return;
        if (button) button.disabled = true;

        fetch(cartUrlRoot + "cart/add.js", {
          method: "POST",
          body: new FormData(form),
          headers: { Accept: "application/json" }
        })
          .then(function (response) {
            if (!response.ok) throw new Error("Unable to add item");
            return fetch(cartUrlRoot + "cart.js", { headers: { Accept: "application/json" } });
          })
          .then(function (response) {
            if (!response.ok) throw new Error("Unable to read cart");
            return response.json();
          })
          .then(function (cart) {
            setCount(cart.item_count);
            if (button) {
              button.classList.add("is-added");
              window.setTimeout(function () {
                button.classList.remove("is-added");
              }, 800);
            }
            notify("Added to cart");
          })
          .catch(function () {
            notify("Please open the product to add it");
          })
          .finally(function () {
            if (button) button.disabled = false;
          });
      });
    });
  });
})();
